<template>
	<div>
		<div class="wrap-navigate">
			<div class="avatar-div">
				<avtarInput
					:avatar="avatar"
					@change="getAvatarUser"
					@imageSavedGetNewImage="getUserProfile()"
					defaultImage="/images/avatar.png"
					:type="'profileImage'"
				></avtarInput>
				<div class="name">{{ profileUser.display_name }}</div>
				<div class="wrap-tooltip">
					<div
						class="edit-profile notification"
						id="adminProfile"
						@click="clickNavigate('admin-profile')"
						v-bind:class="{ active: activeNavigation == 'AdminProfile' }"
					>
						<EditIcon />
					</div>
					<div
						@click="clickNavigate('admin-message')"
						id="adminMessage"
						class="notification"
						v-bind:class="{ active: activeNavigation == 'AdminMessage' }"
						v-b-tooltip.hover
						:title="$t('userDashboard.control.messages')"
					>
						<MessageOutlineIcon />
						<div v-if="unreadMessages > 0" class="notification-number">
							{{ unreadMessages }}
						</div>
					</div>
					<div
						class="logout"
						v-b-tooltip.hover
						:title="$t('userDashboard.navigation.logout')"
						id="logout"
						@click="userLogout"
					>
						<LogoutIcon />
					</div>
				</div>
			</div>
			<div class="navigate">
				<div
					@click="clickNavigate('admin-dashboard')"
					id="adminDashboard"
					class="navigate-item"
					v-bind:class="{ active: activeNavigation == 'AdminMain' }"
				>
					<div class="menu-icon">
						<ViewDashboardIcon />
					</div>
					<div class="menu-item">
						{{ $t('adminDashboard.navigation.control') }}
					</div>
				</div>
				<div
					@click="clickNavigate('admin-approve-listing')"
					id="adminApproveListing"
					class="navigate-item"
					v-bind:class="{ active: activeNavigation == 'AdminApproveListing' }"
				>
					<div class="menu-icon">
						<CheckSquareIcon />
					</div>
					<div class="menu-item">
						{{ $t('adminDashboard.navigation.noticesReview') }}
					</div>
				</div>
				<div
					@click="clickNavigate('admin-manage-listing')"
					id="adminManageListing"
					class="navigate-item"
					v-bind:class="{ active: activeNavigation == 'AdminManageListing' }"
				>
					<div class="menu-icon">
						<FormatListBulletedIcon />
					</div>
					<div class="menu-item">
						{{ $t('adminDashboard.navigation.listings') }}
					</div>
				</div>
				<div
					@click="clickNavigate('admin-manage-listing-sold-rented')"
					id="adminManageListing"
					class="navigate-item"
					v-bind:class="{
						active: activeNavigation == 'AdminManageListingSoldRented'
					}"
				>
					<div class="menu-icon">
						<IconStar />
					</div>
					<div class="menu-item">
						{{ $t('adminDashboard.navigation.soldRented') }}
					</div>
				</div>
				<div
					@click="clickNavigate('admin-manage-users')"
					id="adminManageMember"
					class="navigate-item"
					v-bind:class="{ active: activeNavigation == 'AdminManageUsers' }"
				>
					<div class="menu-icon">
						<UserIcon />
					</div>
					<div class="menu-item">
						{{ $t('adminDashboard.navigation.manageMemberAccounts') }}
					</div>
				</div>

				<div
					@click="clickNavigate('admin-payment-history')"
					id="adminPaymentHistory"
					class="navigate-item"
					v-bind:class="{ active: activeNavigation == 'AdminPaymentHistory' }"
				>
					<div class="menu-icon">
						<CreditCardOutlineIcon />
					</div>
					<div class="menu-item">
						{{ $t('adminDashboard.navigation.paymentHistory') }}
					</div>
				</div>
				<div
					@click="clickNavigate('admin-statistics')"
					id="adminStatistics"
					class="navigate-item"
					v-bind:class="{ active: activeNavigation == 'AdminStatistic' }"
				>
					<div class="menu-icon">
						<TrendingUpIcon />
					</div>
					<div class="menu-item">
						{{ $t('adminDashboard.navigation.statistics') }}
					</div>
				</div>
				<div
					@click="clickNavigate('admin-email')"
					id="emailTemplatePreview"
					class="navigate-item"
					v-bind:class="{
						active: activeNavigation == 'AdminEmailTemplatePreview'
					}"
				>
					<div class="menu-icon">
						<EmailIcon />
					</div>
					<div class="menu-item">
						{{ $t('adminDashboard.navigation.email') }}
					</div>
				</div>
				<div
					@click="clickNavigate('admin-media')"
					id="adminMedia"
					class="navigate-item"
					v-bind:class="{
						active: activeNavigation == 'AdminMedia'
					}"
				>
					<div class="menu-icon">
						<FileMultipleIcon />
					</div>
					<div class="menu-item">
						{{ $t('adminDashboard.navigation.media') }}
					</div>
				</div>
				<div
					@click="clickNavigate('admin-manage-agency')"
					id="AdminManageAgency"
					class="navigate-item"
					v-bind:class="{ active: activeNavigation == 'AdminManageAgency' }"
				>
					<div class="menu-icon">
						<IconPlus />
					</div>
					<div class="menu-item d-flex flex-row justify-content-between align-items-center align-self-center"
						:class="dataAdminDashboard && dataAdminDashboard.agencies_waiting_for_approval?'w-100':''">
						{{ $t('adminDashboard.navigation.agency') }}
						<div
							style="background: red;width: 20px;height: 20px;border-radius: 50%;text-align: center;color: white;"
							v-if="dataAdminDashboard && dataAdminDashboard.agencies_waiting_for_approval"
						>{{dataAdminDashboard.agencies_waiting_for_approval}}</div>
					</div>
				</div>
				<div
					@click="clickNavigate('admin-website-config')"
					id="adminWebsiteConfig"
					class="navigate-item"
					v-bind:class="{ active: activeNavigation == 'AdminWebsiteConfig' }"
				>
					<div class="menu-icon">
						<IconSetting />
					</div>
					<div class="menu-item">
						{{ $t('adminDashboard.navigation.WebsiteSsettings') }}
					</div>
				</div>
				<div
					@click="clickNavigate('admin-add-admin')"
					id="adminAddAdmin"
					class="navigate-item"
					v-bind:class="{ active: activeNavigation == 'AdminAddAdmin' }"
				>
					<div class="menu-icon">
						<IconUserPlusFeather :size="18" />
					</div>
					<div class="menu-item">
						{{ $t('adminDashboard.navigation.Add admin') }}
					</div>
				</div>
				<div
					@click="clickNavigate('admin-special-deals')"
					id="adminManageSpecialDeals"
					class="navigate-item"
					v-bind:class="{ active: activeNavigation == 'AdminManageSpecialDeals' }"
				>
					<div class="menu-icon">
						<IconGift />
					</div>
					<div class="menu-item">
						{{ $t('adminDashboard.navigation.adminManageSpecialDeals') }}
					</div>
				</div>
				<div
					@click="clickNavigate('admin-discount-list')"
					id="AdminDiscountList"
					class="navigate-item"
					v-bind:class="{ active: activeNavigation == 'adminDiscountList' }"
				>
					<div class="menu-icon">
						<PercentOutlineIcon />
					</div>
					<div class="menu-item">
						{{ $t('adminDashboard.navigation.adminDiscountList') }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import EditIcon from '@/components/icons/IconEdit/index';
import MessageOutlineIcon from 'vue-material-design-icons/MessageOutline.vue';
import FileMultipleIcon from 'vue-material-design-icons/FileMultiple.vue';
import LogoutIcon from '@/components/icons/IconLogout/index';
import ViewDashboardIcon from 'vue-material-design-icons/ViewDashboard.vue';
import FormatListBulletedIcon from 'vue-material-design-icons/FormatListBulleted.vue';
import PercentOutlineIcon from 'vue-material-design-icons/PercentOutline.vue';
import CreditCardOutlineIcon from 'vue-material-design-icons/CreditCardOutline.vue';
import TrendingUpIcon from 'vue-material-design-icons/TrendingUp.vue';
import EmailIcon from 'vue-material-design-icons/EmailOutline.vue';
import CheckSquareIcon from '@/components/icons/IconCheckSquare/index';
import UserIcon from '@/components/icons/IconUser/index';
import IconSetting from '@/components/icons/IconSetting/index';
import { SHOW_REJECT_ACCEPT_BUTTON } from '@/controllers/ActionTypes';
import avtarInput from '@/components/newAvtarUploader';
import IconStar from '@/components/icons/IconStar';
import IconPlus from '@/components/icons/IconPlus';
import IconGift from '@/components/icons/IconGift';
import IconUserPlusFeather from '@/components/icons/IconUserPlusFeather';

export default {
	components: {
		IconStar,
		EditIcon,
		MessageOutlineIcon,
		LogoutIcon,
		ViewDashboardIcon,
		FormatListBulletedIcon,
		CreditCardOutlineIcon,
		TrendingUpIcon,
		EmailIcon,
		CheckSquareIcon,
		UserIcon,
		avtarInput,
		IconSetting,
		IconPlus,
		FileMultipleIcon,
		IconGift,
		PercentOutlineIcon,
		IconUserPlusFeather
	},
	props: {
		activeNavigation: {
			type: String,
			default: 'AdminMain'
		}
	},
	data() {
		return {
			profileUser: localStorage.getItem('user_profile')
				? JSON.parse(localStorage.getItem('user_profile'))
				: null,
			avatarNew: null,
			saving: false,
			saved: false,
			avatar: null
		};
	},
	computed: {
		...mapGetters('UserController', ['userProfile']),
		...mapGetters('ChatController', ['unreadMessages']),
		...mapGetters('AdminDashBoardController', ['dataAdminDashboard']),
	},
	mounted() {
		if (this.userProfile) {
		}
		this.getAvatarUser();
		let _this = this;
	},
	watch: {
		userProfile: function(val) {
			if (val) {
			}
		}
	},
	created() {
		this.GET_NUMBER_OF_UNREAD_MESSAGE({ admin: true });
	},
	methods: {
		...mapActions('UserController', ['UPLOAD_AVARTA_USER']),
		...mapActions('ChatController', ['GET_NUMBER_OF_UNREAD_MESSAGE']),
		getUserProfile(){
			console.log("get User Profile")
			this.USER_PROFILE({
              userToken: this.$root.user.access_token,
            }).then((data)=>{
				this.getAvatarUser();
			})
		},
		clickNavigate(page) {
			if (window.location.pathname != this.$i18nRoute({ name: page })) {
				this.$router.push(this.$i18nRoute({ name: page }));
			}
		},
		userLogout() {
			this.$root.signOut();
		},
		uploadImage() {
			this.saving = true;
			setTimeout(() => this.savedAvatar(), 1000);
		},
		savedAvatar() {
			this.saving = false;
			this.saved = true;
		},
		getAvatarUser() {
			if (localStorage && localStorage.getItem('user_profile')) {
				let avatar_url = JSON.parse(localStorage.getItem('user_profile'))
					.profile_image;
				if (avatar_url) {
					this.avatar = avatar_url;
					this.$forceUpdate();
				} else {
					this.avatar = null;
					this.$forceUpdate();
				}
			}
		}
	}
};
</script>
<style lang="scss">
@import 'adminDashboardNavigate.scss';
</style>
